import React, {
  useEffect, useLayoutEffect, useState
} from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { CHART_COLORS_PRIMARY, CHART_MAX_VALUES } from 'constant/variables';

am4core.useTheme(am4themes_animated);

const getSortNames = (name="") => {
  const nameArray = name.split(" ");
  const firstName = nameArray[0];
  let secondSortName = '';
  if(nameArray.length > 1) {
    secondSortName = ` ${nameArray[1].substring(0, 1)}.`;
  }
  return `${firstName}${secondSortName}`;
}

export default function CylinderChart(props) {
  const [chartData, setChartData] = useState([]);
  const { topemp } = props;
  useEffect(() => {
    console.log(topemp)
    if (topemp) {
      if (topemp.length === 0) {
        const chartDetail = [];
        const detail = {
          country: "Not Available",
          visits: 0,
          pareto: 0
        };
        chartDetail.push(detail);
        setChartData(chartDetail);
      } else {
        const comp = topemp;
        const chartDetail = [];
        for (let index = 0; index < comp.length; index++) {
          if((index + 1) > CHART_MAX_VALUES) {
            break;
          }
          var detail = {};
          const name = comp[index].Name || "";
          detail["country"] = getSortNames(name);
          detail["fullName"] = name;
          detail["visits"] = comp[index].Total;
          chartDetail.push(detail);
        }
        setChartData(chartDetail);
      }
    }
  }, [topemp]);
  useLayoutEffect(() => {
    var chart = am4core.create("chartdiv63", am4charts.XYChart3D);
    chart.paddingBottom = 80;
    chart.angle = 35;

    // Add data
    chart.data = chartData

    // Create axes
    var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "country";
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.minGridDistance = 20;
    categoryAxis.renderer.inside = true;
    categoryAxis.renderer.grid.template.disabled = true;
    // categoryAxis.renderer.labels.template.hideOversized = true;
    // categoryAxis.renderer.labels.template.rotation = -90;

    let labelTemplate = categoryAxis.renderer.labels.template;
    // labelTemplate.rotation = 90;
    labelTemplate.horizontalCenter = "middle";
    // labelTemplate.verticalCenter = "right";
    labelTemplate.dy = 20; // moves it a bit down;
    labelTemplate.inside = false; // this is done to avoid settings which are not suitable when label is rotated

    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.grid.template.disabled = true;

    // Create series
    var series = chart.series.push(new am4charts.ConeSeries());
    series.dataFields.valueY = "visits";
    series.dataFields.categoryX = "country";
    series.columns.template.tooltipText = "{fullName}: [bold]{visits}[/]";
    
    // Modify chart's colors
    chart.colors.list = CHART_COLORS_PRIMARY;

    var columnTemplate = series.columns.template;
    columnTemplate.adapter.add("fill", function (fill, target) {
      return chart.colors.getIndex(target.dataItem.index);
    })

    columnTemplate.adapter.add("stroke", function (stroke, target) {
      return chart.colors.getIndex(target.dataItem.index);
    })

    // chart.current = chart;

    return () => {
      chart.dispose();
    };
  }, [chartData]);
  return (
    <div id="chartdiv63" style={{ width: '100%', height: '500px' }} />
  );
}
